import type { V2Asset } from "../types";

export interface ImageEditHistory {
  levels: V2Asset[][];
  count: number;
  missingOriginal: boolean;
}

/** Request revisions and generic source_asset_id links deliberately do not count. */
export function imageEditHistory(current: V2Asset, assets: readonly V2Asset[]): ImageEditHistory {
  const available = new Map(assets.filter(asset => asset.space_id === current.space_id && asset.media_type === "image" && asset.status === "available").map(asset => [asset.id, asset]));
  available.set(current.id, current);
  const visited = new Set<string>();
  let original = current;
  while (original.edit_parent_asset_id && !visited.has(original.edit_parent_asset_id)) {
    visited.add(original.id);
    const parent = available.get(original.edit_parent_asset_id);
    if (!parent) break;
    original = parent;
  }
  const children = new Map<string, V2Asset[]>();
  for (const asset of available.values()) {
    if (!asset.edit_parent_asset_id) continue;
    const siblings = children.get(asset.edit_parent_asset_id) ?? [];
    siblings.push(asset); children.set(asset.edit_parent_asset_id, siblings);
  }
  const levels = [[original]];
  visited.clear(); visited.add(original.id);
  for (let level = 0; level < levels.length; level++) {
    const next = levels[level]!.flatMap(asset => children.get(asset.id) ?? []).filter(asset => {
      if (visited.has(asset.id)) return false;
      visited.add(asset.id); return true;
    }).sort((a, b) => a.created_at.localeCompare(b.created_at) || a.id.localeCompare(b.id));
    if (next.length) levels.push(next);
  }
  return { levels, count: levels.length - 1, missingOriginal: Boolean(original.edit_parent_asset_id) };
}
